import { useState } from 'react';
import ReportService from './ReportService';
import { useSelector } from 'react-redux';

function useReport() {
  const [reportData, setReportData] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const shopName = useSelector((state) => state.shop.name);

  const getAmountSummaryReport = async (formData) => {
    setIsLoading(true);
    try {
      const updatedFormData = {...formData, shop: shopName}
      const response = await ReportService.getAmountSummaryReport(updatedFormData);
      console.log(response.data)
      setReportData(response.data)
      setError(null);
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
      setIsLoading(false);
    }
};

  const getExpenseSummaryReport = async (formData) => {
    setIsLoading(true);
    try {
      const updatedFormData = {...formData, shop: shopName}
      const response = await ReportService.getExpenseSummaryReport(updatedFormData);
      console.log(response.data)
      setReportData(response.data)
      setError(null);
    } catch (err) {
      console.log(err.response.data.message)
      setError(err);
    } finally {
      setIsLoading(false);
    }
};

  const getNewCustomerPerformanceReport = async (formData) => {
    setIsLoading(true);
    try {
      const updatedFormData = {...formData, shop: shopName}
      const response = await ReportService.getNewCustomerPerformanceReport(updatedFormData);
      setReportData(response.data)
      setError(null);
    } catch (err) {
      console.log(err.response.data.message)
      setError(err);
    } finally {
      setIsLoading(false);
    }
};

  const getRegisMonthAmountReport = async (formData) => {
    setIsLoading(true);
    try {
      const updatedFormData = {...formData, shop: shopName}
      const response = await ReportService.getRegisMonthAmountReport(updatedFormData);
      setReportData(response.data)
      setError(null);
    } catch (err) {
      console.log(err.response.data.message)
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const getRegisMonthAmountDetail = async (formData) => {
    setIsLoading(true);
    try {
      const updatedFormData = {...formData, shop: shopName}
      const response = await ReportService.getRegisMonthAmountDetail(updatedFormData);
      console.log(response.data)
      setError(null);
      return (response.data)
    } catch (err) {
      console.log(err.response.data.message)
      setError(err);
    } finally {
      setIsLoading(false);
    }
};

  const getWeightSummaryReport = async (formData) => {
    console.log('get weight')
    setIsLoading(true);
    try {
      const updatedFormData = {...formData, shop: shopName}
      const response = await ReportService.getWeightSummaryReport(updatedFormData);
      console.log(response.data)
      setReportData(response.data)
      setError(null);
    } catch (err) {
      console.log(err.response.data.message)
      setError(err);
    } finally {
      setIsLoading(false);
    }
};

  const getMoneyExchangeSummaryReport = async (formData) => {
    console.log('get weight')
    setIsLoading(true);
    try {
      const response = await ReportService.getMoneyExchangeSummaryReport(formData);
      console.log(response.data)
      setReportData(response.data)
      setError(null);
    } catch (err) {
      console.log(err.response.data.message)
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const getProfitSummaryReport = async (formData) => {
    console.log('get weight')
    setIsLoading(true);
    try {
      const response = await ReportService.getProfitSummaryReport(formData);
      console.log(response.data)
      setReportData(response.data)
      setError(null);
    } catch (err) {
      console.log(err.response.data.message)
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const getReceiptAmountReport = async (period) => {
    setIsLoading(true);
    try {
      const response = await ReportService.getReceiptAmountReport(period);
      console.log(response.data)
      setReportData(response.data)
      setError(null);
    } catch (err) {
      console.log(err.response.data.message)
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const getMonthlyProfitReport = async () => {
    try {
      const response = await ReportService.getMonthlyProfitReport({});
      return response.data.data;
    } catch (error) {
      console.error('Failed to fetch monthly profit data:', error);
      return [];
    }
  };

  const getUnpaidDetailReport = async (monthYear, shop, allTime = false) => {
    try {
      const body = { shop: shop || shopName, allTime: !!allTime };
      if (!allTime) body.monthYear = monthYear;
      const response = await ReportService.getUnpaidDetailReport(body);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch monthly unpaid detail data:', error);
      return [];
    }
  };

  const getCompanyCustomerSummaryReport = async (options = {}) => {
    setIsLoading(true);
    try {
      const response = await ReportService.getCompanyCustomerSummaryReport(options);
      setReportData(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch company customer summary:', err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const getCustomerProfitSummaryReport = async (limit = 100) => {
    setIsLoading(true);
    try {
      const response = await ReportService.getCustomerProfitSummaryReport(limit);
      setReportData(response.data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch customer profit summary:', err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const getCustomerPendingPaymentsReportByShipDate = async (formData) => {
    setIsLoading(true);
    try {
      const updatedFormData = {...formData, shop: shopName}
      const response = await ReportService.getCustomerPendingPaymentsReportByShipDate(updatedFormData);
      console.log(response.data.data)
      setReportData(response.data);
      setError(null);
    } catch (error) {
      console.error('Failed to fetch customer pending payments data:', error);
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    reportData,
    isLoading,
    error,
    getAmountSummaryReport,
    getExpenseSummaryReport,
    getWeightSummaryReport,
    getMoneyExchangeSummaryReport,
    getProfitSummaryReport,
    getNewCustomerPerformanceReport,
    getRegisMonthAmountReport,
    getReceiptAmountReport,
    getRegisMonthAmountDetail,
    getMonthlyProfitReport,
    getUnpaidDetailReport,
    getCustomerPendingPaymentsReportByShipDate,
    getCompanyCustomerSummaryReport,
    getCustomerProfitSummaryReport
  };
}

export default useReport;
